import { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../../utils'
import GoalCard from './GoalCard'
import { FillGaugeCard } from '../IncomeReplacement'
import { Page } from '../elements'

class GoalList extends Component {
  static displayName = 'GoalList'

  static propTypes = {
    goals: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
  }

  render() {
    const {
      goals,
      includeFill,
      store: {
        config: { isSpendown, spendDownModeling },
      },
    } = this.props

    return (
      <Page.GoalsWrapper>
        {includeFill && !isSpendown && !spendDownModeling && (
          <FillGaugeCard name='Percent of income after retiring' />
        )}
        {goals.map(goal => {
          return <GoalCard key={goal.id} goal={goal} />
        })}
      </Page.GoalsWrapper>
    )
  }
}

export default withRouterProps(inject('store')(observer(GoalList)))
